const parseData = (data) => parseInt(data);
const mapData = (link) => (
    {
        link_code: link.data['link_code'],
        follow_log_id: link.data['follow_log_id'],
        require_user_data: link.data['require_user_data'],
        enable_call_rating: link.data['enable_call_rating'],
        background_exist: link.data['background_file_link'],
        logo_exist: link.data['logo_file_link'],
        redirect_address: link.data['redirect_address'],
    }
)
export {parseData, mapData}